import React, { useEffect } from "react";

import { Utils } from "@/common/utils";
import { SelectWrapper } from "Components/Common/SelectWrapper";
import { AppStore, SimpleSchool } from "Stores/appStore";
import { inject, observer } from "mobx-react";
import {useSchoolsOptions} from "@/hooks/schools";


interface SchoolSelectorProps {
    appStore?: AppStore
}

export const SchoolSelector = inject("appStore")(observer((props: SchoolSelectorProps) => {
    const {data} = useSchoolsOptions();
    const [selected, setSelected] = React.useState<SimpleSchool | null>(null);
    const handleSchoolSelection = (selected: SimpleSchool) => {
        props.appStore!.updateSelectedSchool(selected, true);
    };

    const getSchoolName = (school: SimpleSchool) => school.display_name;

    const getSchoolId = (school: SimpleSchool) => school.school_id;

    useEffect(() => {
        if (data && data.length > 0) {
            const chosen_school = localStorage.getItem("chosen_school");
            setSelected(data.find(school => school.school_id === chosen_school) || null);
        }
    }, [data]);

    if (Utils.isSuperAdmin() && data && data.length > 0) {
        return (
            <SelectWrapper<SimpleSchool>
                options={data}
                onChange={handleSchoolSelection}
                placeholder="Choose school"
                value={selected || undefined}
                getOptionLabel={getSchoolName}
                getOptionValue={getSchoolId}
                menuPlacement="top"
            />
        );
    } else {
        return null;
    }
}));
